import { app } from './app/app.js';
import DataRequest from './app/data_request.js';
import { LoginDialog } from './account/login_dialog.js';

// Controls
import './account/profile_button.js';
import './controls/popup_button_control.js';

// Panels
import './account/cancel_pwd_recovery_panel.js';
import './account/contact_us_panel.js';
import './account/login_panel.js';
import './account/signup_panel.js';
import './account/profile_panel.js';
import './account/reset_pwd_panel.js';
import './map/map_panel.js';
import './media/gallery_panel.js';
import './location/loc_panel.js';
import './store/store_panel.js';
import './trip/trip_panel.js';
import './trip-planning/trip_planning_panel.js';

app.initialize({ LoginDialog, dataRequest: DataRequest });

// The app cannot load LoginDialog module because of cyclic imports.
window.onload = () => app.restoreSession();
window.app = app;
